import React, { useState } from "react";
import gif from "../svg x gifs/Login.gif";
import { RiLockPasswordFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { auth } from "../firebaseA";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";

function Signin() {
  const navigate = useNavigate();

  const [mailerror, setmailerror] = useState(false);
  const [passwrod, setpasswrod] = useState(false);
  const [message, setmessage] = useState(false);
  const [fill, setfill] = useState(false);

  const [loginemail, setloginemail] = useState("");
  const [loginpassword, setloginpassword] = useState("");
  async function login() {
    try {
      const user = await signInWithEmailAndPassword(
        auth,
        loginemail,
        loginpassword
      );
      navigate("/Congrats");
    } catch (error) {
      if (
        error.code === "auth/invalid-email" ||
        error.code === "auth/user-disabled" ||
        error.code === "auth/user-not-found"
      ) {
        setmessage(true);
      } else if (error.code === "auth/wrong-password") {
        setpasswrod(true);
      } else if (error.code === "auth/invalid-email") {
        setmailerror(true);
      } else if (error.code === "auth/weak-password") {
        setpasswrod(true);
      } else if (error.code === "auth/internal-error") {
        setfill(true);
      } else {
        console.log(error.message);
        alert(error.message);
      }
    }
  }
  function submit(e) {
    e.preventDefault();
  }

  return (
    <div>
      <div className="w-full h-full fixed inset-0 -z-10 bg-gray-100 md:bg-primary-100" />
      <div className="h-full md:min-h-screen w-full md:w-[95%] lg:w-[90%] 2xl:w-[70%] m-auto z-10 bg-primary-100 flex items-center justify-center ">
        <div className="bg-gray-100 text-gray-500 md:rounded-3xl md:shadow-xl w-full overflow-hidden">
          <div className="md:flex w-full">
            <div className="items-center flex justify-center w-full md:w-1/2 bg-white">
              <img
                className="flex justify-center w-auto max-h-[500px] items-center "
                src={gif}
                alt="Sign In"
              />
            </div>
            <div className="w-full md:w-1/2 py-10 px-5 md:px-10 flex flex-col justify-center items-center">
              <div className="text-center">
                <h1 className="font-bold main-mini-titles text-gray-900">
                  Sign In
                </h1>
                <p className="text-[14px] md:text-[16px]">
                  Please provide your information to complete the sign in
                  process.
                </p>
              </div>
              <form
                onSubmit={submit}
                className="flex flex-col mt-8 md:mt-4 w-full"
              >
                <div className="flex flex-col">
                  <div className="flex flex-col gap-y-2">
                    <div className="flex -mx-3">
                      <div className="w-full px-3">
                        <label for="" className="text-xs font-semibold px-1">
                          Email
                        </label>
                        <div className="flex">
                          <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center">
                            <MdEmail />{" "}
                          </div>
                          <input
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                            onChange={(e) => {
                              setloginemail(e.target.value);
                            }}
                            name="email"
                            type="email"
                            className={`${
                              mailerror
                                ? "w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-red-500 outline-none focus:border-red-500"
                                : "w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-primary-100"
                            }`}
                            placeholder="johnsmith@example.com"
                          />
                        </div>
                        {mailerror && (
                          <p className="text-red-500 text-sm py-2">
                            Invalid mail
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex -mx-3">
                      <div className="w-full px-3">
                        <label for="" className="text-xs font-semibold px-1">
                          Password
                        </label>
                        <div className="flex">
                          <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center">
                            <RiLockPasswordFill />{" "}
                          </div>
                          <input
                            onChange={(e) => {
                              setloginpassword(e.target.value);
                            }}
                            name="password"
                            type="password"
                            className={`${
                              passwrod
                                ? "w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-red-500 outline-none focus:border-red-500"
                                : "w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-primary-100"
                            }`}
                            placeholder="************"
                          />
                        </div>
                        {passwrod && (
                          <p className="text-red-500 text-sm py-2">
                            invalid password
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col mt-6 mb-4">
                    <div className="w-full">
                      <button
                        onClick={login}
                        className="w-full  bg-primary-100 hover:bg-primary-100 focus:bg-primary-100 text-white rounded-lg px-3 py-3 font-semibold"
                      >
                        SIGN UP
                      </button>
                    </div>
                    {message || fill ? (
                      <div className="flex flex-wrap justify-between items-center mt-2">
                        <div className="flex text-red-800 w-full p-4 justify-start space-x-3 bg-red-500/50 border-[1px] border-red-500 rounded-md items-center">
                          <p className="text-red-500 text-sm">User not found</p>
                        </div>
                      </div>
                    ) : null}
                    <div className="flex  text-[14px] md:text-[16px] flex-wrap mt-4 gap-x-2">
                      <h1>Do you not currently have an account?</h1>
                      <Link to="/SignUp">
                        <button className=" text-primary-100 border-b-[1px] ease-in-out duration-500 border-primary-100/0 hover:border-primary-100">
                          Sign Up
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signin;
